import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// import { Guard } from './services/guard.service';
import { LoginComponent } from './pages/common/login/login.component';
/** superadmin components */
import { SuperadminComponent } from './pages/role-specific/superadmin/superadmin.component';
import { SuperadminDashboardComponent } from './pages/role-specific/superadmin/dashboard/dashboard.component';
import { SuperadminUsersOperatorsComponent } from './pages/role-specific/superadmin/users/operators/users.operators.component';
import { SuperadminUsersAgenciesComponent } from './pages/role-specific/superadmin/users/agencies/users.agencies.component';
import { SuperadminUsersAgentsComponent } from './pages/role-specific/superadmin/users/agents/users.agents.component';
// admin components
import { AdminComponent } from './pages/role-specific/admin/admin.component';
import { AdminDashboardComponent } from './pages/role-specific/admin/dashboard/dashboard.component';
import { AdminUsersAgenciesComponent } from './pages/role-specific/admin/users/agencies/users.agencies.component';
import { AdminUsersAgentsComponent } from './pages/role-specific/admin/users/agents/users.agents.component';
import { AdminSalesDocumentsComponent } from './pages/role-specific/admin/sales/documents/sales.documents.component';
/** agency components */
import { AgencyComponent } from './pages/role-specific/agency/agency.component';
import { AgencyDashboardComponent } from './pages/role-specific/agency/dashboard/dashboard.component';
import { AgencySalesDocumentsComponent } from './pages/role-specific/agency/sales/documents/sales.documents.component';
import { AgencyStatisticsComponent } from './pages/role-specific/agency/statistics/statistics.component';
/** agent components */
import { AgentComponent } from './pages/role-specific/agent/agent.component';
import { AgentDashboardComponent } from './pages/role-specific/agent/dashboard/dashboard.component';
import { AgentSalesDocumentsComponent } from './pages/role-specific/agent/sales/documents/sales.documents.component';
import { SuperadminRoutePermissionsComponent } from './pages/role-specific/superadmin/route-permissions/route-permissions.component';
import { PataviumRole } from './models/request-and-responses/rest-api/enums/role.enum.model';
import {
    AuthGuardAgency,
    AuthGuardAgencyOperator,
    AuthGuardAgent,
    AuthGuardOperator,
    AuthGuardSpecializedOperator
} from './services/auth.service';
import { AgencyAgentsComponent } from './pages/role-specific/agency/users/agents/agents.component';
import { AgencyOperatorsComponent } from './pages/role-specific/agency/users/agency-operators/agency-operators.component';
import { ContractComponent } from './pages/common/contract/contract.component';
import { CustomerComponent } from './pages/common/customer/customer.component';
import { PasswordResetComponent } from './components/password-reset/password-reset.component';
import { PricelistComponent } from './pages/common/pricelist/pricelist.component';
import { ProfileComponent } from './pages/common/profile/profile.component';
import { SuperadminSpecializedOperatorsComponent } from './pages/role-specific/superadmin/users/specialized-operators/superadmin-specialized-operators.component';
import { SpecializedOperatorComponent } from './pages/role-specific/specialized-operator/specialized-operator.component';
import { ContractFromFileComponent } from './pages/common/contract-from-file/contract-from-file.component';
import { SuperadminUsersAgencyOperatorsComponent } from './pages/role-specific/superadmin/users/agency-operators/users.agency-operators.component';
import { SuperadminTemplatesComponent } from './pages/role-specific/superadmin/templates/templates.component';

const routes: Routes = [
    { path: '', component: LoginComponent, pathMatch: 'full' },
    {
        path: 'password-reset',
        component: PasswordResetComponent
    },
    {
        path: 'superadmin',
        component: SuperadminComponent,
        children: [
            { path: 'dashboard', component: SuperadminDashboardComponent },
            { path: 'users/operators', component: SuperadminUsersOperatorsComponent },
            {
                path: 'users/specialized-operators',
                component: SuperadminSpecializedOperatorsComponent
            },
            { path: 'users/agencies', component: SuperadminUsersAgenciesComponent },
            { path: 'users/agency-operators', component: SuperadminUsersAgencyOperatorsComponent},
            { path: 'users/agents', component: SuperadminUsersAgentsComponent },
            { path: 'profile', component: ProfileComponent },
            {
                path: 'contracts/contracts',
                component: ContractComponent
            },
            {
                path: 'contracts/customers',
                component: CustomerComponent
            },
            { path: 'contracts/contracts-from-file', component: ContractFromFileComponent },
            {
                path: 'route-permissions/operator',
                component: SuperadminRoutePermissionsComponent,
                data: { _role: PataviumRole.BackOfficeOperator, _roleName: 'Operatore' }
            },
            {
                path: 'route-permissions/agency',
                component: SuperadminRoutePermissionsComponent,
                data: { _role: PataviumRole.Agency, _roleName: 'Team' }
            },
            {
                path: 'route-permissions/agent',
                component: SuperadminRoutePermissionsComponent,
                data: { _role: PataviumRole.Agent, _roleName: 'Venditore' }
            },
            {
                path: 'route-permissions/agency-operator',
                component: SuperadminRoutePermissionsComponent,
                data: { _role: PataviumRole.AgencyOperator, _roleName: 'Operatore team' }
            },
            {
                path: 'route-permissions/specialized-operator',
                component: SuperadminRoutePermissionsComponent,
                data: {
                    _role: PataviumRole.SpecializedOperator,
                    _roleName: 'Operatore specializzato'
                }
            },
            {
                path: 'sms',
                component: SuperadminTemplatesComponent
            }
        ]
    },
    {
        path: 'admin',
        component: AdminComponent,
        canActivateChild: [AuthGuardOperator],
        children: [
            {
                path: 'dashboard',
                component: AdminDashboardComponent
            },
            { path: 'users/agencies', component: AdminUsersAgenciesComponent },
            { path: 'users/agents', component: AdminUsersAgentsComponent },
            {
                path: 'contracts/contracts',
                component: ContractComponent
            },
            {
                path: 'contracts/customers',
                component: CustomerComponent
            },
            { path: 'sales/documents', component: AdminSalesDocumentsComponent },
            { path: 'sales/pricelists', component: PricelistComponent },
            { path: 'profile', component: ProfileComponent }
        ]
    },
    {
        path: 'agency',
        component: AgencyComponent,
        canActivateChild: [AuthGuardAgency],
        children: [
            { path: 'dashboard', component: AgencyDashboardComponent },
            { path: 'agents', component: AgencyAgentsComponent },
            { path: 'agency-operators', component: AgencyOperatorsComponent },
            {
                path: 'contracts/contracts',
                component: ContractComponent
            },
            {
                path: 'contracts/customers',
                component: CustomerComponent
            },
            { path: 'sales/documents', component: AgencySalesDocumentsComponent },
            { path: 'sales/pricelists', component: PricelistComponent },
            { path: 'statistics', component: AgencyStatisticsComponent },
            { path: 'profile', component: ProfileComponent }
        ]
    },
    {
        path: 'agency-operator',
        component: AgencyComponent,
        canActivateChild: [AuthGuardAgencyOperator],
        children: [
            { path: 'dashboard', component: AgencyDashboardComponent },
            { path: 'agents', component: AgencyAgentsComponent },
            {
                path: 'contracts/contracts',
                component: ContractComponent
            },
            {
                path: 'contracts/customers',
                component: CustomerComponent
            },
            { path: 'sales/documents', component: AgencySalesDocumentsComponent },
            { path: 'sales/pricelists', component: PricelistComponent },
            { path: 'statistics', component: AgencyStatisticsComponent },
            { path: 'profile', component: ProfileComponent }
        ]
    },
    {
        path: 'agent',
        component: AgentComponent,
        canActivateChild: [AuthGuardAgent],
        children: [
            { path: 'dashboard', component: AgentDashboardComponent },
            {
                path: 'contracts/contracts',
                component: ContractComponent
            },
            {
                path: 'contracts/customers',
                component: CustomerComponent
            },
            { path: 'sales/documents', component: AgentSalesDocumentsComponent },
            { path: 'sales/pricelists', component: PricelistComponent },
            { path: 'profile', component: ProfileComponent }
        ]
    },
    {
        path: 'specialized-operator',
        component: SpecializedOperatorComponent,
        canActivateChild: [AuthGuardSpecializedOperator],
        children: [
            {
                path: 'contracts/contracts',
                component: ContractComponent
            },
            { path: 'profile', component: ProfileComponent }
        ]
    },
    // {
    //     path: '**',
    //     component: PageNotFoundComponent
    // }
    // otherwise redirect to login
    { path: '**', redirectTo: '' }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            onSameUrlNavigation: 'reload',
            useHash: false
        })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts